import { TutorTimeslots } from "@models/tutor-timeslots";
import { Booking } from "@models/booking";
import { WorkshopAbsence } from "@models/workshop-absence";
import { Contact } from "@models/contact";

export class BookingsStore {

  constructor(
    public timeslots: TutorTimeslots[] = [],
    public editableBooking: Booking = null,
    public editableWorkshopAbsence: WorkshopAbsence = null,
    public affectedBookings: Booking[] = [],
    public potentialStudents: Contact[] = [],
    public replacementTutors: Contact[] = [],
  ) {}

  static clone(store: BookingsStore) {
    const result = new this()

    result.timeslots = [...store.timeslots]
    result.editableBooking = store.editableBooking
    result.editableWorkshopAbsence = store.editableWorkshopAbsence
    result.affectedBookings = [...store.affectedBookings]
    result.potentialStudents = [...store.potentialStudents]
    result.replacementTutors = [...store.replacementTutors]

    return result
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/store/bookings.ts